import { createContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ComposerMetadataContext = /*#__PURE__*/createContext({
  reply: null,
  setComposerMetadata: () => {}
});
export const ComposerMetadataProvider = ({
  children
}) => {
  const [composerMetadata, setComposerMetadata] = useState({
    reply: null
  });
  return /*#__PURE__*/_jsx(ComposerMetadataContext.Provider, {
    value: Object.assign({}, composerMetadata, {
      setComposerMetadata
    }),
    children: children
  });
};
ComposerMetadataProvider.displayName = 'ComposerMetadataProvider';